import { render, staticRenderFns } from "./blackListCorpDetail.vue?vue&type=template&id=14c4d6f0&scoped=true&"
import script from "./blackListCorpDetail.vue?vue&type=script&lang=js&"
export * from "./blackListCorpDetail.vue?vue&type=script&lang=js&"
import style0 from "./blackListCorpDetail.vue?vue&type=style&index=0&id=14c4d6f0&prod&lang=less&scoped=true&"
import style1 from "./blackListCorpDetail.vue?vue&type=style&index=1&id=14c4d6f0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c4d6f0",
  null
  
)

export default component.exports